<div class="loading mh-100">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    <div class="lds_text">Loading content...</div>
</div>